export default "__VITE_ASSET__ZmE0qbhC__"